import { BaseView } from "~/components";
import "~/views/main/home/style.css";
import HeroSection from "./components/HeroSection";
import BenefitsSection from "./components/BenefitsSection";
import HighlightsSection from "./components/HighlightsSection";
import "./style.css";

const TmsPage = () => (
  <BaseView>
    <div className="dev-tms-page">
    <HeroSection />
    <BenefitsSection />
    <HighlightsSection />
    </div>
  </BaseView>
);

export default TmsPage;
